import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { pick } from 'lodash';

/**
 * ListActionStatuses
 *
 * Retrieves a list of action statuses from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const ListActionStatuses = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];
    const thePagination = pick(thePayload, ['page', 'size', 'sort']);

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': '/code-lists/categories/RecordActionStatus',
      },
      method: 'GET',
      params: { ...{ apiKey: theApiKey, queryKey: theQueryKey }, ...thePagination },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/Action/api/requests/queries/ListActionStatuses.js -> ListActionStatuses()',
      false,
      error
    );

    throw error;
  }
};
